module.exports = __webpack_public_path__ + "img/flight_land.dc829675.svg";